import React from 'react';
import {
  FDBodyText, FDDisplayText, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import {
  ExploreItems,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep/Content/Sections/ExploreSection/ExploreItems';
import { dataAttrs } from 'Helpers/Testing';
import {
  ExploreAssumptionsItems,
} from './ExploreAssumptionsItems';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDDisplayText,
    _customProps: { color: 'textSecondary', align: 'center' },
  }, overrideReadOnly)
  .nameOverride(['subtitle'], {
    _component: () => FDBodyText,
    _customProps: { align: 'center' },
  }, overrideReadOnly)
  .nameOverride(['exploreAssumptions'], {
    _component: () => ExploreAssumptionsItems,
  }, overrideReadOnly)
  .nameOverride(['exploreItems'], {
    _component: () => ExploreItems,
  }, overrideReadOnly);

export const ExploreSectionLayout = ({ resource }) => {
  return (
    <FDStack direction={'column'} spacing={4} alignItems={'stretch'} {...dataAttrs('goal-strategy-detail-explore-section')}>
      <MetaControl attrName={'title'} resource={resource} metaOverrideSet={metaOverrides} />
      <MetaControl attrName={'subtitle'} resource={resource} metaOverrideSet={metaOverrides} />
      <MetaControl attrName={'exploreItems'} resource={resource} metaOverrideSet={metaOverrides} />
      <MetaControl attrName={'exploreAssumptions'} resource={resource} metaOverrideSet={metaOverrides} />
    </FDStack>
  );
};

ExploreSectionLayout.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
